import script from "./DataInconsistencyTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataInconsistencyTable.vue?vue&type=script&setup=true&lang=ts"

import "./DataInconsistencyTable.vue?vue&type=style&index=0&id=7c5d8857&lang=scss"

const __exports__ = script;

export default __exports__